import { Navigate, Route, Routes } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth'
// layouts
import DashboardLayout from './layouts/dashboard';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ApplicationManager from './pages/ApplicationManager';
import LoadingDisplay from './pages/LoadingDisplay';
import ApplicationPage from './pages/ApplicationPage';
import BoltonCargoLogo from './utils/bolton-cargo.png';
import { auth } from './auth/firebase';

// ----------------------------------------------------------------------



export default function Router() {
  const [user, loading, error] = useAuthState(auth)
  const [admin, setAdmin] = useState(false)
  // const [adminLoading, setAdminLoading] = useState(true)
  useEffect(() => {
    if (user) {
      user.getIdTokenResult()
        .then((idTokenResult) => {
          if (idTokenResult.claims.admin) {
            setAdmin(true)
          } else {
            setAdmin(false)
          }
          // setAdminLoading(false)
        })
    }

  }, [user, loading]);



  const PrivateRoute = ({ element }) => {
    if (loading) {
      return <LoadingDisplay />;
    }
    if (user) {
      return element
    }
    return <Page404 />

  };

  // const AdminRoute = ({ element }) => {
  //   if (adminLoading) {
  //     return <LoadingDisplay />;
  //   }
  //   if (admin) {
  //     return element
  //   }
  //   return <Page404 />

  // };


  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<LoginPage />} />
      <Route path="/application-form" element={<ApplicationPage />} exact />
      <Route path="/application-form/bolton-cargo" element={<ApplicationPage logo={BoltonCargoLogo} companyName="Bolton Cargo" />} exact />
      <Route path="/dashboard/" element={<PrivateRoute element={<DashboardLayout admin={admin} />} exact />}>
        <Route index element={<Navigate to="/dashboard/applications" />} exact />
        <Route path="applications" element={<ApplicationManager />} exact />
      </Route>
      <Route path="/404" element={<Page404 />} />
      <Route path="*" element={<Navigate to="/404" />} />
    </Routes>
  );

}

